class Overlay {
  constructor() {
    this.classes = {
      active: 'overlay--active',
    };

    this.toggle = this.toggle.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);

    this.create = this.create.bind(this);
    this.selector = false;
  }

  create(selector) {
    this.element = document.createElement('div');
    this.element.classList.add('overlay');
    this.element.setAttribute('data-close', '');

    if (selector && selector !== '') {
      let target = selector;

      if (typeof selector === 'string' || selector instanceof String) {
        target = document.querySelector(selector);
      }

      if (target) {
        this.selector = target;
        target.appendChild(this.element);
      }
    } else {
      document.body.appendChild(this.element);
    }
  }

  toggle() {
    if (this.element.classList.contains(this.classes.active)) {
      this.hide();
    } else {
      this.show();
    }
  }

  show(selector) {
    let overlay = this.element;
    if (selector) overlay = Overlay.getoverlay(selector);

    overlay.classList.add(this.classes.active);
  }

  hide(selector) {
    let overlay = this.element;
    if (selector) overlay = Overlay.getoverlay(selector);

    overlay.classList.remove(this.classes.active);
  }

  static getoverlay(selector) {
    const matches = [...selector.children].filter((item) => item.classList.contains('overlay'));
    if (matches) return matches[0];
    return false;
  }
}

const overlay = new Overlay();

export const { show, hide, create } = overlay;
